import {isEmpty as _isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {compose} from 'redux';
import {reduxForm} from 'redux-form';
import {Button, Header, Popup, Segment} from 'semantic-ui-react';

import {gql, graphql, withApollo} from 'react-apollo';
import {FormWrapper} from '@appComponents/HOCFormWrapper';
import {getLink} from '@appComponents/Link';
import Form from '@appComponents/ReduxFormControls';
import Authorization from '@appComponents/Authorization';
import * as formUtils from '@utils/forms';
import {formModel} from '@utils/forms';
import mapModulesToProps from '@utils/mapModulesToProps';
import {validatorTypes} from '@utils/validators';
import { BASE_FORM_MESSAGES, DELETE_HEADER, DELETING } from '@constants/messages';
import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';
import {bookmakersListQuery} from '@graphql/bookmaker';
import * as clientGraphQl from '@graphql/clients/index';
import {
    clientFormData,
    getBookmakerOption,
    getClientTypesData,
    getLBCPlaybackEnabled,
    getNotificationRecipients,
    onChangeNotificationEmailRecipients,
    searchBookmaker,
    toggleOption,
} from '@modules/client/utils/clientFormHelpers';
import {isClientDeletable} from '@modules/client/utils/clientDeleteHelpers';
import {
    DELETE_DISABLED_TOOLTIP,
    DELETE_ERROR_CONTACT_TEAM,
    DELETE_MODAL_HEADER,
} from '@modules/client/constants/messages';

import validate from './validator';

class ClientForm extends React.Component {
    static propTypes = {
        client: PropTypes.object,
        clientData: PropTypes.object,
        CreateClient: PropTypes.func,
        dataForForm: PropTypes.object,
        dataMap: PropTypes.object,
        DeleteClient: PropTypes.func,
        Entity: PropTypes.shape({
            setEntity: PropTypes.func.isRequired,
        }),
        formData: PropTypes.object,
        handleSubmit: PropTypes.func,
        history: PropTypes.object,
        MessageBox: PropTypes.object,
        Modal: PropTypes.object,
        submitting: PropTypes.bool,
        UpdateClient: PropTypes.func,
    };

    static defaultProps = {
        clientData: null,
    };

    constructor(props) {
        super(props);

        const clientTypes = [
            {value: 1, key: 'Betting'},
            {value: 2, key: 'Non-betting'},
        ];

        this.state = {
            loadingBookmakers: false,
            bookmakerOption: [],
            clientTypesOption: clientTypes,
            clientTypesSelected: [],
            notificationEmailRecipients: [],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            id: client_id,
            client_types: currentClientTypes,
            is_lbc_stream_playback_enabled: currisLbcStreamPlaybackEnabled,
            notification_email_recipients: currNotificationEmailRecipients,
        } = this.props.dataForForm.client;

        const {
            client_types: previousClientTypes,
            is_lbc_stream_playback_enabled: previsLbcStreamPlaybackEnabled,
            notification_email_recipients: prevNotificationEmailRecipients,
        } = prevProps.dataForForm.client;

        const {clientTypes: currentClientTypesList} = this.props.dataForForm;
        const {clientTypes: previousClientTypesList} = prevProps.dataForForm;

        if (!this.state.dataReceived && client_id) {
            const selectedClientTypes = getClientTypesData(currentClientTypes, previousClientTypes);
            const clientTypes = getClientTypesData(currentClientTypesList, previousClientTypesList, true);
            const bookmakerOption = getBookmakerOption(this.state.bookmakerOption, this.props.formData.client.bookmaker);
            const isLbcStreamPlaybackEnabled = getLBCPlaybackEnabled(currisLbcStreamPlaybackEnabled, previsLbcStreamPlaybackEnabled);
            const notificationEmailRecipients = getNotificationRecipients(currNotificationEmailRecipients, prevNotificationEmailRecipients);

            this.setState(() => ({
                dataReceived: true,
                bookmakerOption: bookmakerOption,
                clientTypesOption: !_isEmpty(clientTypes) ? clientTypes : prevState.clientTypesOption,
                clientTypesSelected: selectedClientTypes,
                is_lbc_stream_playback_enabled: isLbcStreamPlaybackEnabled,
                notificationEmailRecipients: notificationEmailRecipients,
            }));
        }
    }

    onFormSubmit(data) {
        const dataToSave = {
            ...this.props.dataMap.client, ...data,
            bookmaker: data.bookmaker !== undefined ? parseInt(data.bookmaker) : null,
            crm_id: data.crm_id !== undefined ? parseInt(data.crm_id) : null,
            country: parseInt(data.country_id),
            is_lbc_stream_playback_enabled: this.state.is_lbc_stream_playback_enabled !== undefined ?
                this.state.is_lbc_stream_playback_enabled : false,
            notification_email_recipients: this.state.notificationEmailRecipients,
        };

        const redirectAfterCreating = (data) => {
            this.props.history.push(getLink('clients.edit', {id: data.data.createClient.id}));
        };

        const updateClientDataInStore = (data) => {
            this.props.Entity.setEntity({
                name: 'client',
                data: {...this.props.clientData, bookmaker: data.data.updateClient.bookmaker},
            });
        };

        return formUtils.onSubmit({
            dataToSave,
            actions: {create: this.props.CreateClient, update: this.props.UpdateClient},
            message: {
                box: this.props.MessageBox,
                boxName: {success: 'clientMessage', error: 'clientMessage'},
                text: { ...BASE_FORM_MESSAGES },
                entityLabel: 'client',
                entityName: data.name,
            },
            callback: {
                created: redirectAfterCreating,
                updated: updateClientDataInStore,
            },
            props: {Model: formModel},
        });
    }

    deleteClient = () => {
        const redirectAfterDeleting = () => {
            this.props.history.replace('/clients');
        };

        const showDeleteErrorModal = () => {
            this.props.Modal.setModalError({
                header: DELETE_MODAL_HEADER,
                text: DELETE_ERROR_CONTACT_TEAM,
                isVisible: true,
            });
        };

        return formUtils.onDelete({
            id: parseInt(this.props.formData.client.id, 10),
            action: this.props.DeleteClient,
            message: {
                box: this.props.MessageBox,
                boxName: {success: 'clientMessageIndex', error: 'clientMessage'},
                text: {
                    ...BASE_FORM_MESSAGES,
                    DELETE_IN_PROGRESS: () => DELETING('client', this.props.dataForForm.client.name),
                    NOT_DELETED: () => DELETE_ERROR_CONTACT_TEAM,
                },
                entityLabel: 'client',
                entityName: this.props.dataForForm.client.name,
            },
            callback: {
                deleted: redirectAfterDeleting,
                notDeleted: showDeleteErrorModal,
            },
            props: {Model: formModel},
        });
    };

    deleteButtonClick = (e) => {
        e.preventDefault();

        this.props.Modal.setModalConfirmation({
            header: <Header icon='trash' content={DELETE_HEADER('client')}/>,
            onYes: this.deleteClient,
            text: `Are you sure you want to delete the client "${this.props.dataForForm.client.name}"?`,
        });
    };

    renderDeleteButton = () => {
        const client = this.props.dataForForm.client;

        if (client.id === undefined || '' === client.id) {
            return null;
        }

        const canDelete = isClientDeletable(client.creation_datetime);
        const deleteButton = (
            <Button
                onClick={this.deleteButtonClick}
                color='red'
                disabled={this.props.submitting || !canDelete}
                icon='trash'
                content='Delete'
            />
        );

        if (canDelete) {
            return deleteButton;
        }

        return (
            <Popup
                on='hover'
                content={DELETE_DISABLED_TOOLTIP}
                trigger={<span>{deleteButton}</span>}
            />
        );
    };

    render() {
        return (
            <Form.Create
                loading={(this.props.formData !== undefined) ? this.props.formData.loading : false}
                onSubmit={this.props.handleSubmit((values) => {
                    return this.onFormSubmit(values);
                })}
            >
                <Form.IdField
                    defaultValue={this.props.dataForForm.client.id}
                />
                <Form.FormRowBookmaker
                    allowClear
                    loading={this.state.loadingBookmakers}
                    onSearchChange={
                        (e, target) => searchBookmaker(
                            e,
                            target,
                            this.props.client,
                            bookmakersListQuery,
                            this.setState.bind(this)
                        )}
                    options={this.state.bookmakerOption}
                    value={this.props.dataForForm.client}
                />
                <Form.FormRowName
                    defaultValue={this.props.dataForForm.client.crm_id}
                    label='CRM ID'
                    name='crm_id'
                    width='one'
                />
                <Form.FormRowName
                    defaultValue={this.props.dataForForm.client.name}
                    required
                />
                <Form.FormRowName
                    defaultValue={this.props.dataForForm.client.brands}
                    label='Brands'
                    name='brands'
                />
                <Form.FormRowAddress
                    defaultValue={this.props.dataForForm.client.address}
                />
                <Form.FormRowCountry
                    options={this.props.dataForForm.countries}
                    value={this.props.dataForForm.client}
                />
                <Form.FormRow
                    className='inline'
                    component={Form.SemanticCheckboxList}
                    defaultValue={this.state.clientTypesSelected}
                    label='Type'
                    name='client_types'
                    options={this.state.clientTypesOption}
                    required
                />
                <Form.FormRowVatNumber
                    defaultValue={this.props.dataForForm.client.vat_number}
                />
                <Form.FormRow
                    component={Form.SemanticInput}
                    defaultValue={this.props.dataForForm.client.is_internal || false}
                    label='Internal client'
                    name='is_internal'
                    type='checkbox'
                />
                <Form.FormRow
                    component={Form.SemanticInput}
                    defaultValue={this.props.dataForForm.client.is_strategic || false}
                    label='Strategic client'
                    name='is_strategic'
                    type='checkbox'
                />
                <Form.FormRow
                    addItemShortcuts={[',', ';']}
                    component={Form.SemanticInput}
                    defaultValueMultiple={this.state.notificationEmailRecipients}
                    label='Notification email recipients'
                    name='notification_email_recipients'
                    type='multiple'
                    onChange={(data) => onChangeNotificationEmailRecipients(data, this.setState.bind(this))}
                    renderLabelParams={{
                        className: 'invalid',
                        condition: validatorTypes.email.validate,
                    }}
                />
                <Form.FormRow
                    component={Form.SemanticInput}
                    name='is_lbc_stream_playback_enabled'
                    label='Stream playback in LBC'
                    onCheckboxChange={(data) => toggleOption(data.checked, 'is_lbc_stream_playback_enabled', this.setState.bind(this))}
                    checked={this.state.is_lbc_stream_playback_enabled}
                    type='toggle'
                />
                <Form.FormRowNotes
                    defaultValue={this.props.dataForForm.client.notes}
                />
                <Form.FormRow
                    component={Form.SemanticInput}
                    defaultValue={this.props.dataForForm.client.is_disabled || false}
                    label='Disabled'
                    name='is_disabled'
                    type='checkbox'
                />
                <Form.FormRowChangelog
                    resources={RESOURCES.CLIENT}
                    data={this.props.dataForForm.client}
                />
                <Segment className='formRow form__footer'>
                    <label/>
                    <Button
                        color='blue'
                        content={this?.props?.formData?.variables?.id ? 'Save' : 'Create'}
                        disabled={this.props.submitting}
                        icon='save'
                        loading={this.props.submitting}
                        type='submit'
                    />
                    <Authorization
                        privileges={CONST.SECURITY_PRIVILEGES_DELETE}
                        resources={RESOURCES.CLIENT}
                    >
                        {this.renderDeleteButton()}
                    </Authorization>
                </Segment>
            </Form.Create>
        );
    }
}

export { ClientForm };

const ClientMutations = {
    CreateClient: gql`${clientGraphQl.clientCreateMutation}`,
    DeleteClient: gql`${clientGraphQl.clientDeleteMutation}`,
    UpdateClient: gql`${clientGraphQl.clientUpdateMutation}`,
};

const ClientFormWithRedux = reduxForm({
    form: 'Client',
    validate,
})(withRouter(ClientForm));

const mapDispatchToProps = mapModulesToProps(['Entity']);

const mapStateToProps = (state) => ({
    clientData: undefined !== state.app.entities.client ? state.app.entities.client : null,
});

export default connect(mapStateToProps, mapDispatchToProps)(compose(
    graphql(ClientMutations.CreateClient, {name: 'CreateClient'}),
    graphql(ClientMutations.DeleteClient, {name: 'DeleteClient'}),
    graphql(ClientMutations.UpdateClient, {name: 'UpdateClient'})
)(FormWrapper(clientFormData, (withApollo)(ClientFormWithRedux))));
